var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "desr" }, [
        _vm._v("\n    QCharts 是一个基于\n    "),
        _c("a", { attrs: { href: "https://www.spritejs.com/" } }, [
          _vm._v("spritejs")
        ]),
        _vm._v(
          "\n    封装的图表库，可以让用户以组件的形式组合出各种图表，\n    "
        ),
        _c(
          "a",
          {
            attrs: {
              target: "_blank",
              href: "https://github.com/qcharts/quickstart"
            }
          },
          [_vm._v("→Quickstart")]
        ),
        _vm._v("。\n    如果你使用Vue或者React，可以使用\n    "),
        _c("a", { attrs: { href: "https://www.qcharts.cn/qcharts-vue/" } }, [
          _vm._v("QChartsVue")
        ]),
        _vm._v(" 或\n    "),
        _c("a", { attrs: { href: "https://www.qcharts.cn/qcharts-react/" } }, [
          _vm._v("QChartsReact")
        ])
      ]),
      _vm._v(" "),
      _c("section", { staticClass: "intro" }, [
        _c("h5", [_vm._v("折线图")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/line/default" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/base-line.png",
                  alt: "基础折线图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/line/double" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/double-line.png",
                  alt: "双折线图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/line/smooth" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/curve-line.png",
                  alt: "双曲线"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/line/multi" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/multi-line.png",
                  alt: "多折线"
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("h5", [_vm._v("面积图")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/area/default" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/base-area.png",
                  alt: "基础折线图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/area/stack" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/stack-area.png",
                  alt: "堆叠面积图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/area/range" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/range-area.png",
                  alt: "区间面积图"
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("h5", [_vm._v("柱状图")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/column/default" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/base-column.png",
                  alt: "基础柱状图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/column/group" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/group-column.png",
                  alt: "分组柱状图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/column/stack" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/stack-column.png",
                  alt: "堆叠柱状图"
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("h5", [_vm._v("条形图")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/bar/default" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/bar-chart.png",
                  alt: "基础条形图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/bar/group" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/group-bar-chart.png",
                  alt: "分组条形图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/bar/stack" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/stack-bar-chart.png",
                  alt: "堆叠条形图"
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("h5", [_vm._v("饼图")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/pie/default" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/base-pie.png",
                  alt: "基础饼图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/pie/arcPie" } }, [
              _c("img", {
                attrs: {
                  src: "https://p5.ssl.qhimg.com/t01f7d072b3c5a144d3.png",
                  alt: "弧饼图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/pie/dounght" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/dounght.png",
                  alt: "环形图"
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("h5", [_vm._v("雷达图")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/radar/default" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/base-radar.png",
                  alt: "基础雷达图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/radar/radarPoint" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/radar-double.png",
                  alt: "双色雷达图 "
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("h5", [_vm._v("散点图")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/scatter/scatter" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/scatter.png",
                  alt: "基础散点图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/scatter/bubble" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/scatter-bubble.png",
                  alt: "气泡图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/scatter/bubble2" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/scatter-bubble2.png",
                  alt: "文字气泡图"
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("h5", [_vm._v("漏斗图")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/funnel/default" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/base-funnel.png",
                  alt: "基础漏斗图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/funnel/others" } }, [
              _c("img", {
                attrs: {
                  src:
                    "https://p4.ssl.qhimg.com/d/inn/717a6a22789a/funnel-other.png",
                  alt: "其它漏斗图"
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("h5", [_vm._v("仪表盘")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/gauge/default" } }, [
              _c("img", {
                attrs: {
                  src: "https://p0.ssl.qhimg.com/t019a02888f6b738828.jpg",
                  alt: "仪表盘"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/gauge/tick" } }, [
              _c("img", {
                attrs: {
                  src: "https://p3.ssl.qhimg.com/t01212f91f46fe5e82a.jpg",
                  alt: "其它"
                }
              })
            ])
          ])
        ]),
        _vm._v(" "),
        _c("h5", [_vm._v("极坐标柱状图")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/polarBar/default" } }, [
              _c("img", {
                attrs: {
                  src: "https://p4.ssl.qhimg.com/t01a8ebbbb1be84b2bd.png",
                  alt: "基础柱状图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/polarBar/group" } }, [
              _c("img", {
                attrs: {
                  src: "https://p5.ssl.qhimg.com/t019b534af0c9649b6b.png",
                  alt: "分组柱状图"
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("li", [
            _c("a", { attrs: { href: "./#/demo/polarBar/stack" } }, [
              _c("img", {
                attrs: {
                  src: "https://p5.ssl.qhimg.com/t016cd0f3d3185f3026.png",
                  alt: "堆叠柱状图"
                }
              })
            ])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }